import useGeneralLoader from "./useGeneralLoader";

export const SITE_OFFLINE_UID = 'site.offline';

export const useSiteOffline = () => {
    return useGeneralLoader(SITE_OFFLINE_UID, 'api/auth/offline/status', 'offline', 'offline');
};